import React, { useState, useEffect } from 'react';
import { getAllAdminUsers, deleteAdminUser, updateAdminUser, registerAdminUser } from '../../api/apiServiceFetch';
import ConfirmPopup from '../../components/ConfirmPopup';
import { useTranslation } from '../../contexts/TranslationContext';
import './AdminUsers.scss';

const AdminUsers = () => {
    const { t } = useTranslation()
    const [adminUsers, setAdminUsers] = useState([]);
    const [expandedUserId, setExpandedUserId] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newAdminUser, setNewAdminUser] = useState({
        fullName: '',
        login: '',
        password: '',
        isActive: false
    });
    const [showConfirmPopup, setShowConfirmPopup] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);

    useEffect(() => {
        const fetchAdminUsers = async () => {
            try {
                const users = await getAllAdminUsers();
                setAdminUsers(users);
            } catch (error) {
                console.error('Failed to load admin users:', error);
            }
        };

        fetchAdminUsers();
    }, []);

    const handleExpandClick = (userId) => {
        setExpandedUserId(expandedUserId === userId ? null : userId);
    };

    const handleActivateDeactivate = async (userId) => {
        const target = adminUsers.find(user => user.adminUserId === userId);
        if (!target) return;
        const nextIsActive = !target.isActive;
        try {
            await updateAdminUser({
                adminUserId: target.adminUserId,
                userName: target.userName,
                fullName: target.fullName,
                // Backend marks Login as [Required] but never persists it.
                login: target.userName,
                isActive: nextIsActive,
                isSuperAdmin: !!target.isSuperAdmin,
            });
            setAdminUsers(prev => prev.map(user =>
                user.adminUserId === userId ? { ...user, isActive: nextIsActive } : user
            ));
        } catch (error) {
            console.error('Update admin user error:', error);
        }
    };

    const handleDelete = (userId) => {
        setUserToDelete(userId);
        setShowConfirmPopup(true);
    };

    const confirmDelete = async () => {
        if (userToDelete !== null) {
            try {
                await deleteAdminUser({ adminUserId: userToDelete });
                setAdminUsers(adminUsers.filter(user => user.adminUserId !== userToDelete));
            } catch (error) {
                console.error('Delete error:', error);
            }
            setShowConfirmPopup(false);
            setUserToDelete(null);
        }
    };

    const handleEdit = (userId) => {
        alert(`Edit admin user ID: ${userId}`);
    };

    const handleInsert = async () => {
        try {
            await registerAdminUser({
                fullName: newAdminUser.fullName,
                // Backend logs admins in by UserName; the form's "Login" maps to it.
                userName: newAdminUser.login,
                password: newAdminUser.password,
                retypePassword: newAdminUser.password,
                isActive: newAdminUser.isActive,
            });
            const users = await getAllAdminUsers();
            setAdminUsers(users);
            setNewAdminUser({
                fullName: '',
                login: '',
                password: '',
                isActive: false
            });
            setIsModalOpen(false);
        } catch (error) {
            console.error('Register admin user error:', error);
        }
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const cancelDelete = () => {
        setShowConfirmPopup(false);
        setUserToDelete(null);
    };

    return (
        <div className="AdminUsers">
            <button onClick={toggleModal}>+</button>
            {isModalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        <h3>Новый админ</h3>
                        <input
                            type="text"
                            placeholder="Full Name"
                            value={newAdminUser.fullName}
                            onChange={(e) => setNewAdminUser({ ...newAdminUser, fullName: e.target.value })}
                        />
                        <input
                            type="text"
                            placeholder="Login"
                            value={newAdminUser.login}
                            onChange={(e) => setNewAdminUser({ ...newAdminUser, login: e.target.value })}
                        />
                        <input
                            type="password"
                            placeholder="Password"
                            value={newAdminUser.password}
                            onChange={(e) => setNewAdminUser({ ...newAdminUser, password: e.target.value })}
                        />
                        <label>
                            <input
                                type="checkbox"
                                checked={newAdminUser.isActive}
                                onChange={(e) => setNewAdminUser({ ...newAdminUser, isActive: e.target.checked })}
                            />
                            Active
                        </label>
                        <button onClick={handleInsert}>Создать</button>
                        <button onClick={toggleModal}>Отменить</button>
                    </div>
                </div>
            )}
            {adminUsers.map(user => (
                <div key={user.adminUserId} className="admin-user-card">
                    <div className="admin-user-summary" onClick={() => handleExpandClick(user.adminUserId)}>
                        <h2>{user.fullName}</h2>
                        <p>{user.userName}</p>
                        <p><input type='checkbox' checked={!!user.isActive} readOnly></input></p>

                    </div>
                    {expandedUserId === user.adminUserId && (
                        <div className="admin-user-details">
                            <p>Дата входа: {user.lastLoginDate}</p>
                            <p>Дата создания: {user.createDate}</p>
                            <div className="actions">
                                <button onClick={() => handleActivateDeactivate(user.adminUserId)}>
                                    {user.isActive ? "Деактивировать" : "Активировать"}
                                </button>
                                {/* <button onClick={() => handleEdit(user.adminUserId)}>{t('edit')}</button> */}
                                <button onClick={() => handleDelete(user.adminUserId)}>Удалить</button>
                            </div>
                        </div>
                    )}
                </div>
            ))}
            {showConfirmPopup && (
                <ConfirmPopup
                    isOpen={showConfirmPopup}
                    onConfirm={confirmDelete}
                    onCancel={cancelDelete}
                />
            )}
        </div>
    );
};

export default AdminUsers;
